// @flow
import React from "react";
import { CaretUp } from "styled-icons/fa-solid/CaretUp";
import { CaretDown } from "styled-icons/fa-solid/CaretDown";

type Props = {
  expanded: boolean,
  size: number
};

export default class Expander extends React.Component<Props> {
  static defaultProps = {
    size: 15
  };

  render() {
    const { expanded, size } = this.props;
    return expanded ? (
      <CaretDown style={{ marginRight: 10 }} size={size} />
    ) : (
      <CaretUp style={{ marginRight: 10 }} size={size} />
    );
  }
}
